module.exports = __webpack_public_path__ + "static/media/login-side-original.9e03f36d.jpg";